import React from 'react';
import PropTypes from 'prop-types';
import { FDBox } from '@facet-wealth/design';
import AccordionStepper from 'Components/ComponentLibrary/Organisms/AccordionStepper';

const NextUpTabSummaryTimeline = ({ resource }) => {
  const [selectedGroupIndex, setSelectedGroupIndex] = React.useState(0);

  const timelines = resource.attr('nextUpSummaryTimeline').resources().list();
  const timeline = resource.attr('nextUpSummaryTimeline').resources().index(selectedGroupIndex);

  const hasPreviousStep = selectedGroupIndex > 0;
  const hasNextStep = selectedGroupIndex < timelines.length - 1;

  return (
    <FDBox padding={400}>
      <AccordionStepper
        resource={timeline}
        hasPreviousStep={hasPreviousStep}
        onPreviousClick={() => setSelectedGroupIndex(prev => prev - 1)}
        hasNextStep={hasNextStep}
        onNextClick={() => setSelectedGroupIndex(prev => prev + 1)}
        emptyStateLabel="No actions to display for the selected month."
      />
    </FDBox>
  );
};

NextUpTabSummaryTimeline.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default NextUpTabSummaryTimeline;
